import type { Template } from "@/types";

export const PO_06_H2_V4: Template[] = [
{
    id: "po-06-h2v4-01",
    name: "PO 01 - H2V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h2_v4_01.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 45, y: 224, width: 241, height: 403, rotation: 0, imageRotation: 0 },
            { id: "2", x: 294, y: 224, width: 265, height: 198, rotation: 0, imageRotation: 0 },
            { id: "3", x: 294, y: 431, width: 265, height: 197, rotation: 0, imageRotation: 0 },
            { id: "4", x: 655, y: 163, width: 339, height: 525, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1000, y: 163, width: 167, height: 258, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1000, y: 430, width: 167, height: 258, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h2v4-02",
    name: "PO 02 - H2V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h2_v4_02.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 134, y: 163, width: 343, height: 525, rotation: 0, imageRotation: 0 },
            { id: "2", x: 666, y: 163, width: 366, height: 258, rotation: 0, imageRotation: 0 },
            { id: "3", x: 666, y: 430, width: 366, height: 258, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1040, y: 163, width: 110, height: 170, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1040, y: 341, width: 110, height: 169, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1040, y: 519, width: 110, height: 169, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h2v4-03",
    name: "PO 03 - H2V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h2_v4_03.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 47, y: 224, width: 254, height: 402, rotation: 0, imageRotation: 0 },
            { id: "2", x: 309, y: 224, width: 253, height: 198, rotation: 0, imageRotation: 0 },
            { id: "3", x: 309, y: 431, width: 253, height: 197, rotation: 0, imageRotation: 0 },
            { id: "4", x: 716, y: 224, width: 259, height: 402, rotation: 0, imageRotation: 0 },
            { id: "5", x: 983, y: 224, width: 127, height: 197, rotation: 0, imageRotation: 0 },
            { id: "6", x: 983, y: 430, width: 127, height: 197, rotation: 0, imageRotation: 0 }
    ],
},

//{
//    id: "po-06-h2v4-04",
//    name: "PO 04 - H2V4",
//    albumType: "PO",
//    thumbnail: "/thumbnails/PO/po-06-h2_v4_04.png",
//    size: [1217, 851],
//    style: {},
//    slots: [
//            { id: "1", x: 73, y: 187, width: 463, height: 297, rotation: 0, imageRotation: 0 },
//            { id: "2", x: 73, y: 493, width: 110, height: 171, rotation: 0, imageRotation: 0 },
//            { id: "3", x: 191, y: 493, width: 110, height: 171, rotation: 0, imageRotation: 0 },
//            { id: "4", x: 310, y: 493, width: 109, height: 171, rotation: 0, imageRotation: 0 },
//            { id: "5", x: 427, y: 493, width: 109, height: 171, rotation: 0, imageRotation: 0 },
//            { id: "6", x: 759, y: 187, width: 307, height: 476, rotation: 0, imageRotation: 0 }
//    ],
//},

{
    id: "po-06-h2v4-05",
    name: "PO 05 - H2V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h2_v4_05.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 63, y: 430, width: 484, height: 332, rotation: 0, imageRotation: 0 },
            { id: "2", x: 63, y: 89, width: 238, height: 332, rotation: 0, imageRotation: 0 },
            { id: "3", x: 310, y: 89, width: 238, height: 332, rotation: 0, imageRotation: 0 },
            { id: "4", x: 672, y: 89, width: 483, height: 332, rotation: 0, imageRotation: 0 },
            { id: "5", x: 672, y: 430, width: 238, height: 332, rotation: 0, imageRotation: 0 },
            { id: "6", x: 918, y: 430, width: 237, height: 332, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h2v4-06",
    name: "PO 06 - H2V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h2_v4_06.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 49, y: 159, width: 508, height: 337, rotation: 0, imageRotation: 0 },
            { id: "2", x: 49, y: 505, width: 122, height: 188, rotation: 0, imageRotation: 0 },
            { id: "3", x: 179, y: 505, width: 122, height: 188, rotation: 0, imageRotation: 0 },
            { id: "4", x: 309, y: 505, width: 121, height: 188, rotation: 0, imageRotation: 0 },
            { id: "5", x: 438, y: 505, width: 121, height: 188, rotation: 0, imageRotation: 0 },
            { id: "6", x: 657, y: 244, width: 513, height: 363, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h2v4-07",
    name: "PO 07 - H2V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h2_v4_07.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 49, y: 159, width: 165, height: 264, rotation: 0, imageRotation: 0 },
            { id: "2", x: 49, y: 432, width: 165, height: 263, rotation: 0, imageRotation: 0 },
            { id: "3", x: 222, y: 432, width: 165, height: 263, rotation: 0, imageRotation: 0 },
            { id: "4", x: 395, y: 432, width: 165, height: 263, rotation: 0, imageRotation: 0 },
            { id: "5", x: 222, y: 159, width: 337, height: 264, rotation: 0, imageRotation: 0 },
            { id: "6", x: 657, y: 244, width: 513, height: 363, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-06-h2v4-08",
    name: "PO 08 - H2V4",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-06-h2_v4_08.png",
    size: [1217, 851],
    style: {},
    slots: [
            { id: "1", x: 0, y: 0, width: 609, height: 851, rotation: 0, imageRotation: 0 },
            { id: "2", x: 673, y: 165, width: 358, height: 256, rotation: 0, imageRotation: 0 },
            { id: "3", x: 673, y: 430, width: 358, height: 256, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1038, y: 165, width: 107, height: 168, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1038, y: 341, width: 107, height: 168, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1038, y: 518, width: 107, height: 168, rotation: 0, imageRotation: 0 }
    ],
},

//{
//    id: "po-06-h2v4-09",
//    name: "PO 09 - H2V4",
//    albumType: "PO",
//    thumbnail: "/thumbnails/PO/po-06-h2_v4_09.png",
//    size: [1217, 851],
//    style: {},
//    slots: [
//            { id: "1", x: 46, y: 144, width: 177, height: 278, rotation: 0, imageRotation: 0 },
//            { id: "2", x: 46, y: 431, width: 177, height: 277, rotation: 0, imageRotation: 0 },
//            { id: "3", x: 231, y: 144, width: 809, height: 564, rotation: 0, imageRotation: 0 },
//            { id: "4", x: 1048, y: 144, width: 118, height: 183, rotation: 0, imageRotation: 0 },
//            { id: "5", x: 1048, y: 335, width: 118, height: 182, rotation: 0, imageRotation: 0 },
//            { id: "6", x: 1048, y: 526, width: 118, height: 182, rotation: 0, imageRotation: 0 }
//    ],
//},

//{
//    id: "po-06-h2v4-10",
//    name: "PO 10 - H2V4",
//    albumType: "PO",
//    thumbnail: "/thumbnails/PO/po-06-h2_v4_10.png",
//    size: [1217, 851],
//    style: {},
//    slots: [
//            { id: "1", x: 57, y: 169, width: 686, height: 513, rotation: 0, imageRotation: 0 },
//            { id: "2", x: 751, y: 169, width: 200, height: 304, rotation: 0, imageRotation: 0 },
//            { id: "3", x: 959, y: 169, width: 200, height: 304, rotation: 0, imageRotation: 0 },
//            { id: "4", x: 751, y: 482, width: 131, height: 201, rotation: 0, imageRotation: 0 },
//            { id: "5", x: 890, y: 482, width: 131, height: 201, rotation: 0, imageRotation: 0 },
//            { id: "6", x: 1029, y: 482, width: 131, height: 201, rotation: 0, imageRotation: 0 }
//    ],
//}
];